const sessionStorageUtils = {
  set: function (key, value) {
    sessionStorage.setItem(key, JSON.stringify(value))
  },
  get: function (key) {
    const value = sessionStorage.getItem(key)
    if (!value) {
      return null
    }
    try {
      const jsonValue = JSON.parse(value)
      if (typeof jsonValue === 'object') {
        return jsonValue
      }
    } catch (e) {
      return value
    }
  },
  remove: function (key) {
    sessionStorage.removeItem(key)
  }
}

export { sessionStorageUtils }
